import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconExclamationSolid } from '../Icons';

const PhysicianChatContactListImportantEmptyState = () => {
  const { t } = useTranslation('components', {
    keyPrefix: 'PhysicianChatContactList.EmptyState.important',
  });

  return (
    <div className="flex w-full flex-col items-center">
      <span className="mb-6 text-center text-lg font-semibold text-slate-700">{t('title')}</span>
      <div className="align-center mb-6 w-[80%] rounded border border-slate-200 p-3">
        <span className="text-sm text-slate-600">{t('card_title')}</span>
        <div className="flex gap-3">
          <IconExclamationSolid className="text-red-500" />
          <div className="h-full w-full">
            <div className="my-2 h-3 w-full rounded-full bg-slate-200" />
            <div className="mb-2 h-3 w-full rounded-full bg-slate-200" />
            <div className="mb-4 h-3 w-[40%] rounded-full bg-slate-200" />
          </div>
        </div>
      </div>
      <p className="text-center text-base text-slate-700">
        {t('info')}
        <a
          href="https://medflex.de/hilfe/behandler/nachrichten-markieren-loeschen"
          className="text-blue-500 hover:text-blue-600"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('link')}
        </a>
      </p>
    </div>
  );
};

export default PhysicianChatContactListImportantEmptyState;
